// extracted by mini-css-extract-plugin
module.exports = {"sample-list":"sample-list-b45e40c36f1b854b203ddb0b1016d0d9"};